import { useState } from 'react';

import styled from '@emotion/styled';
import toast from 'react-hot-toast';

import { PrimaryBlackButton, PrimaryWhiteButton } from '../../../components/Button/Buttons';

// Ten one-time recovery codes, shown once (ops spec D18/D19). The admin must
// confirm they saved them before moving on.
const RecoveryCodes: React.FC<{ codes: string[]; onDone: () => void; doneLabel?: string }> = ({ codes, onDone, doneLabel = "I've saved them" }) => {
  const [copied, setCopied] = useState(false);
  return (
    <Box>
      <h3>Save your recovery codes</h3>
      <p>
        If you lose every device with your passkey, one of these codes lets you sign in once and add a new passkey. Each
        works once. They won’t be shown again: copy them somewhere safe, like a password manager.
      </p>
      <Codes>
        {codes.map((code) => (
          <code key={code}>{code}</code>
        ))}
      </Codes>
      <Actions>
        <PrimaryWhiteButton
          type='button'
          onClick={() =>
            navigator.clipboard.writeText(codes.join('\n')).then(
              () => {
                setCopied(true);
                toast.success('Copied');
              },
              () => toast.error('Copy failed. Select the codes and copy them by hand.')
            )
          }
        >
          {copied ? 'Copied' : 'Copy codes'}
        </PrimaryWhiteButton>
        <PrimaryBlackButton type='button' onClick={onDone}>
          {doneLabel}
        </PrimaryBlackButton>
      </Actions>
    </Box>
  );
};

export default RecoveryCodes;

const Box = styled.div`
  display: flex;
  flex-direction: column;
  gap: 12px;

  h3 {
    margin: 0;
  }
  p {
    margin: 0;
    font-size: 14px;
    color: ${({ theme }) => theme.palette.grayTextColor};
  }
`;

const Codes = styled.div`
  display: grid;
  grid-template-columns: repeat(2, 1fr);
  gap: 8px;

  code {
    font-size: 15px;
    padding: 8px 10px;
    border-radius: 8px;
    background: #f3f1ea;
    text-align: center;
    letter-spacing: 0.04em;
  }
`;

const Actions = styled.div`
  display: flex;
  gap: 8px;
  flex-wrap: wrap;
`;
